const { CURB_HEIGHT } = require('./street-segment-utils');

function streetmixUserToAPI(userURL) {
  // this takes in a user facing Streetmix.net URL like https://streetmix.net/kfarr/3/a-frame-city-builder-street-only
  // and turns it into the API redirect URL like https://streetmix.net/api/v1/streets?namespacedId=3&creatorId=kfarr
  var pathArray = new URL(userURL).pathname.split('/');
  const creatorId = decodeURIComponent(pathArray[1]);
  const namespacedId = pathArray[2];
  const baseUrl = 'https://streetmix.net';

  if (creatorId === '-') {
    return baseUrl + '/api/v1/streets?namespacedId=' + namespacedId;
  } else {
    return (
      baseUrl +
      '/api/v1/streets?namespacedId=' +
      namespacedId +
      '&creatorId=' +
      encodeURIComponent(creatorId)
    );
  }
}
module.exports.streetmixUserToAPI = streetmixUserToAPI;

function pathStartsWithAPI(urlString) {
  // First, check the URL path to see if it starts with /api/
  const url = document.createElement('a');
  url.href = urlString;
  const pathname = url.pathname;
  const topDir = pathname.split('/')[1];
  return topDir === 'api';
}
module.exports.pathStartsWithAPI = pathStartsWithAPI;

function streetmixAPIToUser(APIURL) {
  // this takes in a Streetmix.net API redirect URL like https://streetmix.net/api/v1/streets?namespacedId=3&creatorId=kfarr
  // and turns it into the user facing friendly Streetmix.net URL like https://streetmix.net/kfarr/3/a-frame-city-builder-street-only

  // modified from: https://stackoverflow.com/questions/2090551/parse-query-string-in-javascript
  function getQueryVariable(queryString, variable) {
    var vars = queryString.split('&');
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) === variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    console.log('Query variable %s not found', variable);
  }
  var queryString = new URL(APIURL).search.substring(1);
  var namespacedId = getQueryVariable(queryString, 'namespacedId');
  var creatorId = getQueryVariable(queryString, 'creatorId');
  if (typeof creatorId === 'undefined') {
    creatorId = '-';
  }

  return 'https://streetmix.net/' + creatorId + '/' + namespacedId;
}
module.exports.streetmixAPIToUser = streetmixAPIToUser;

// Convert metric elevation (from schemaVersion 33+) to integer level
// Curb height is 0.15m, so we divide by that to get integer levels
// e.g., 0m → 0, 0.15m → 1, 0.30m → 2, 0.75m → 5
function metricElevationToLevel(elevation) {
  if (elevation === undefined || elevation === null) {
    return 0;
  }
  return Math.round(elevation / CURB_HEIGHT);
}
module.exports.metricElevationToLevel = metricElevationToLevel;

// convert all feet values to meters for schemaVersion < 30
// convert metric elevation to integer levels for schemaVersion >= 33
function convertStreetValues(streetData) {
  if (streetData.schemaVersion < 30) {
    // convert width from feet to meters
    streetData.segments.forEach((segmentData) => {
      segmentData.width *= 0.3048;
    });
    if (streetData.width) streetData.width *= 0.3048;
  }

  // For schemaVersion 33+, elevation is in meters - convert back to integer levels
  if (streetData.schemaVersion >= 33) {
    streetData.segments.forEach((segmentData) => {
      if (segmentData.elevation !== undefined) {
        segmentData.elevation = metricElevationToLevel(segmentData.elevation);
      }
    });
  }

  return streetData;
}
module.exports.convertStreetValues = convertStreetValues;
